export function cn(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

export function formatBytes(bytes: number) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

/** "rapor.pdf" -> "rapor" */
export function baseName(name: string) {
  const i = name.lastIndexOf(".");
  return i > 0 ? name.slice(0, i) : name;
}

/**
 * Üretilen dosyayı kullanıcıya indirtir.
 *
 * ÖNEMLİ: Bağlantı tıklanmadan ÖNCE belgeye eklenmelidir. Chrome belgeye
 * bağlı olmayan bir <a> üzerinde de indirmeyi başlatır, ancak Firefox ve
 * bazı tarayıcılar kopuk düğümdeki programatik tıklamayı yok sayar — indirme
 * hiç başlamaz, hata da vermez. Bu yüzden ekle → tıkla → kaldır sırası izlenir.
 */
export function download(data: Blob | Uint8Array | string, filename: string, type?: string) {
  const blob =
    data instanceof Blob
      ? data
      : new Blob([data as BlobPart], { type: type ?? "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Nesne URL'i hemen iptal edilirse indirme yarıda kalabilir; tarayıcıya süre tanı.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * Görseli canvas'a çizilebilir bir bitmap'e çevirir.
 *
 * `new Image()` + `decode()` KULLANMIYORUZ: kullanıcı sekmeyi arka plana
 * alırsa tarayıcı çizim döngüsünü durduruyor ve decode() hiçbir zaman
 * tamamlanmıyor. createImageBitmap görünürlükten bağımsız çalışır.
 */
export async function loadImage(kaynak: Blob | string): Promise<ImageBitmap> {
  const blob = typeof kaynak === "string" ? await (await fetch(kaynak)).blob() : kaynak;
  try {
    return await createImageBitmap(blob);
  } catch {
    // SVG gibi bazı türlerde <img> + canvas üzerinden geçiyoruz
    const url = URL.createObjectURL(blob);
    try {
      const img = new Image();
      img.src = url;
      await img.decode();
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext("2d")!.drawImage(img, 0, 0);
      return await createImageBitmap(canvas);
    } finally {
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  }
}

export function canvasToBlob(canvas: HTMLCanvasElement, type: string, quality?: number) {
  return new Promise<Blob>((resolve, reject) =>
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("Görsel oluşturulamadı"))),
      type,
      quality,
    ),
  );
}
